import ProfileTableColumnResolver from "../../Table/Columns/resolver";
import ProfileTableNoDataResolver from "../../Table/NoDataView/resolver";

const foreignWorkerGroupView = (data) => {
  const formGroupData =
    data &&
    data.getForeignWorkerGroupById &&
    data.getForeignWorkerGroupById &&
    data.getForeignWorkerGroupById.ForeignWorkerGroupFormData;
  const formData = data && data.getForeignWorkerByGroupId;
  let filteredFWs = [];
  let ids;
  const columns = ProfileTableColumnResolver(
    "foreign-worker-group-action-view-columns"
  );
  const noData = ProfileTableNoDataResolver("foreign-worker");

  if (formGroupData) {
    for (const key of Object.keys(formGroupData)) {
      if (key === "new_group_fw_profiles") {
        ids = formGroupData[key];
      }
    }

    for (const e of formData) {
      if (!!ids) {
        for (const x of ids) {
          //eslint-disable-next-line
          if (x == e.id) {
            filteredFWs.push(e);
          }
        }
      }
    }
  }

  const fwTableData = {
    data: filteredFWs,
    columns: columns,
    id: "profile-name",
    noData: noData,
  };

  return fwTableData;
};

export default foreignWorkerGroupView;
